export enum DroppablePrefix {
    REPORT = 'report-',
}

export const REPORT_DROPABLES = {
    REPORT_TYPE_BUILDING_BLOCKS: `${DroppablePrefix.REPORT}typeBuildingBlocks`,
    REPORT_PAPERSHEET: `${DroppablePrefix.REPORT}paperSheet`,
    MEMORY_BAR: `${DroppablePrefix.REPORT}memoryBar`,
};



// WEBPACK FOOTER //
// ./src/beautiful-dnd/Droppable.ts